module.exports = __webpack_public_path__ + "img/placeholder.2a48efd.webp";